<template>
  <div id="app">
    <transition :name="transitionName">
      <navigation>
        <router-view class="Router">
        </router-view>
      </navigation>
    </transition>
  </div>
</template>
<script>
export default {
  name: 'app',
  data () {
    return {
      transitionName: ''
    }
  },
  created () {
    this.$navigation.on('forward', (to, from) => {
      if (to.route && to.route.name === 'videoPlayer') {
        this.transitionName = ''
      } else {
        this.transitionName = 'slide-left'
      }
    })
    this.$navigation.on('back', (to, from) => {
      this.transitionName = 'slide-right'
    })
    this.$navigation.on('replace', (to, from) => {
      this.transitionName = 'slide-right'
    })
  }
}
</script>

<style lang="scss">
/* 在线链接服务仅供平台体验和调试使用，平台不承诺服务的稳定性，企业客户需下载字体包自行发布使用并做好备份。 */
@font-face {
  font-family: 'HSQH';  /* Project id 1308306 */
  src: url('//at.alicdn.com/t/c/font_1308306_4bjxeh671oj.woff2?t=1713236907217') format('woff2'),
       url('//at.alicdn.com/t/c/font_1308306_4bjxeh671oj.woff?t=1713236907217') format('woff'),
       url('//at.alicdn.com/t/c/font_1308306_4bjxeh671oj.ttf?t=1713236907217') format('truetype');
  }
.HSQH {
  font-family: "HSQH" !important;
  font-size: 30px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -webkit-text-stroke-width: 0.2px;
  -moz-osx-font-smoothing: grayscale;
}
#app{
  margin:0 auto;
  height:100%;
  position: relative;
  // overflow-x: hidden;
}
.Router {
  position: absolute;
  width: 100%;
  transition: all .4s ease;
}

.slide-left-enter,
.slide-right-leave-active {
  opacity: 0;
  -webkit-transform: translate(100%, 0);
  transform: translate(100%, 0);
}
.slide-right-enter,
.slide-left-leave-active{
  opacity: 0;
  -webkit-transform: translate(-100%, 0);
  transform: translate(-100% 0);
}
html,body{
  height:100%;
}
.msg{
  .mint-toast-text{
    font-size: 24px;
  }
}
.cropper-view-box img{
  max-width: none;
}
.mint-field-clear{
  i{
    font-size: 30px;
  }
}
.mint-header {
  box-shadow: 0 0.026667rem 0.053333rem 0 rgba(0,0,0,.12), 0 0 0.08rem 0 rgba(0,0,0,.04);
  color: #333;
  height: 85px;
  font-size: 30px;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1000;
  .mintui {
    font-size: 40px;
  }
  .mint-header-title {
    line-height: 85px;
    color: #fff;
    font-size: 34px;
  }
}
img.mescroll-totop {
  width: 80px;
  height: 80px;
  right: 30px;
  bottom: 40px;
}
.mescroll-downwarp .downwarp-tip, .mescroll-upwarp .upwarp-tip, .mescroll-upwarp .upwarp-nodata {
  font-size: 30px !important;
}
@media (min-width: 1200px) {
  .mint-header {
    width: 1200px;
    left: 50%;
    margin-left: -600px;
  }
  .main {
    .swiper-tab {
      width: 1200px !important;
      left: 50% !important;
      margin-left: -600px;
    }
    .list-content {
      width: 1200px;
    }
    .mescroll-upwarp {
      width: 1200px;
    }
  }
}
.p-t85 {
  padding-top: 85px;
}
.login-content {
  .mint-cell-wrapper {
    align-items: center;
  }
  .mint-cell {
    min-height: 70px;
  }
  .mint-cell-wrapper {
    display: flex;
    align-items: center;
  }
  .mint-field {
    padding-bottom: 40px;
  }
  .mint-field .mint-cell-title {
    width: 100px;
    line-height: 70px;
    font-size: 24px;
    color: #999;
  }
  .mint-field-core {
    border: 1px solid #e5e5e5; /* no */
    height: 80px;
    padding-left: 20px;
    width: 400px;
    flex: none;
    font-size: 28px;
  }
}
.exam-content {
  .mint-popup-bottom {
    width: 100%;
    height: 100%;
    padding-top: 85px;
  }
}
div.mint-msgbox {
  width: 6.5rem;
}
div.mint-msgbox-content {
  padding-top: 0;
}
div.mint-msgbox-title {
  line-height: 60px;
  color: #333;
  font-size: 28px;
}
div.mint-msgbox-message {
  padding:  10px 0;
  line-height: 40px;
  color: #333;
  font-size: 26px;
}
div.mint-msgbox-btns {
  height: 60px;
}
button.mint-msgbox-btn {
  line-height: 60px;
}
.mint-cell:last-child, .mint-cell-wrapper {
  background-image: none;
}
.mint-indicator, .mint-toast{
  z-index: 2010 !important;
  position: fixed;
}
.mint-msgbox-wrapper{
  position: absolute;
  z-index: 3005 !important;
}
img.mescroll-totop {
  width: 80px;
  height: 80px;
  right: 30px;
  bottom: 40px;
}
.mescroll-downwarp .downwarp-tip, .mescroll-upwarp .upwarp-tip, .mescroll-upwarp .upwarp-nodata {
  font-size: 30px !important;
}
// 消息提示框样式覆盖
div.mint-msgbox {
  width: 6.5rem;
}
div.mint-msgbox-content {
  padding-top: 0;
}
div.mint-msgbox-title {
  line-height: 80px;
  color: #333;
  font-size: 32px;
}
div.mint-msgbox-message {
  padding:  10px 0;
  line-height: 40px;
  color: #333;
  font-size: 26px;
  font-size: 30px;
}
div.mint-msgbox-btns {
  height: 80px;
  font-size: 30px;
}
button.mint-msgbox-btn {
  line-height: 80px;
  font-size: 30px;
}
.msg .mint-toast-text {
  font-size: 30px;
}
.notice-info {
  font-size: .346667rem;
  color: #bbb;
  text-align: center;
  position: relative;
  position: absolute;
  bottom: 50px;
  left: 0;
  width: 100%;
  z-index: 0;
}
.mint-toast-text {
  font-size: 30px;
}
.el-icon-check:before {
  font-size: 90px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue